<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de clase de peligro</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Nombre">
                    <b-form-input v-model="filterCategoriesSga.name" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Estado">
                    <el-select v-model="filterCategoriesSga.is_active" clearable filterable size="medium"
                        placeholder="Buscar por estado">
                        <el-option v-for="item in statesSga" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchCategoriesSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <el-tooltip effect="light" placement="top" popper-class="py-1 px-2" content="Sincronizar idiomas">
                        <b-button variant="warning" class="ml-1 mr-1" @click="asyncLanguagesCategoriesSga">
                            <i class="fa fa-language" aria-hidden="true"></i>
                        </b-button>
                    </el-tooltip>
                    <b-button v-if="canManageConfiguration" variant="primary" @click="createCategory">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nueva clase de peligro'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_categories" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nueva' }} categoría
                </template>
                <formCategories />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="categories.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        <template #cell(edition)="data">
                            <b-badge variant="info" class="text-white"
                                v-text="data.item.sga_type_of_danger.version.version" />
                        </template>
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                                v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                <el-tooltip content="Editar" placement="top" effect="light">
                                    <el-button type="text" class="text-primary" @click="editCategory(data.item)">
                                        <i class="fa fa-edit fa-lg"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterCategoriesSga.page"
                            :total="filterCategoriesSga.total" :current-page="filterCategoriesSga.page"
                            :page-size="filterCategoriesSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import formCategories from './FormCategories.vue';
export default {
    name: 'Categories',
    components: {
        formCategories,
    },
    data() {
        return {            
        };
    },

    computed: {
        ...mapState('sgaCategories', ['categories', 'action', 'filterCategoriesSga']),
        ...mapState('sgaVersions', ['statesSga', 'activeGlobalVersion', 'activeVersions']),
        canManageConfiguration() {
            const activeVersion = this.activeVersions && this.activeVersions.find(v => v.id === this.activeGlobalVersion);
            
            const isVersionLocked = (activeVersion && activeVersion.is_locked) || false;
            
            return !isVersionLocked;
        },
        fields() {
            const baseFields = [
                {
                    key: "edition",
                    label: "Edición",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "code",
                    label: "Codigo",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "name",
                    label: "Nombre",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "sga_type_of_danger.name",
                    label: "Tipo de peligro",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ];

            if (this.canManageConfiguration) {
                baseFields.push({
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                });
            }

            return baseFields;
        }
    },

    watch: {

        'activeGlobalVersion'(next, prev) {
            if (next != prev && next) {
                this.setEditionToFilterCategoriesSga(this.activeGlobalVersion)
                this.searchCategoriesSga();
            }
        }

    },

    methods: {
        ...mapActions('sgaCategories', ['getCategoriesSga', 'changeStatusCategorySga', 'showCategorySga', 'asyncLanguagesCategoriesSga']),
        ...mapMutations('sgaCategories', ['setActionCategory', 'setDefaultFilterSgaCategories', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination', 'setCategorieSga', 'setEditionToFilterCategoriesSga']),

        createCategory() {
            this.setActionCategory('create');
            this.$bvModal.show('modal_create_categories');
        },

        async clearFilter() {
            this.setDefaultFilterSgaCategories();
            this.setEditionToFilterCategoriesSga(this.activeGlobalVersion)
            await this.getCategoriesSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getCategoriesSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getCategoriesSga();
        },

        async changeStatus(id) {
            await this.changeStatusCategorySga(id);
            await this.getCategoriesSga();
        },

        editCategory(category) {
            this.showCategorySga(category.id);
            this.setActionCategory('edit');
            this.$bvModal.show('modal_create_categories');
        },

        async searchCategoriesSga() {
            await this.getCategoriesSga(true);
        },
    },
};
</script>
